import React, { useState, useEffect } from "react";

import { ExpandMore } from "@mui/icons-material";
import TableComponent from "components/common/TableComponent";

import { ONE_TIME_PAYMENT_BREAKDOWN_COLUMNS } from "./utils";

import "./PaymentBreakdown.scss";

function OneTimePaymentBreakdown({ employeesBreakdown = [] }) {
  const [isExpanded, setIsExpanded] = useState(true);
  const [tableData, setTableData] = useState([]);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    const transformedData = employeesBreakdown.map((employee, index) => {
      const employeeId = employee.employeeId || `employee-${index}`;
      const { fee, discounts, total, description, implementationFee } = employee;

      return {
        id: employeeId,
        description,
        implementationFee,
        fee,
        discount: discounts,
        total,
      };
    });

    setTableData(transformedData);
  }, [employeesBreakdown]);

  return (
    <div className="payment-breakdown-container">
      <div className="payment-breakdown-header" onClick={handleToggle}>
        <h3 className="heading-h4-semibold color-text-heading-primary">Payment breakdown</h3>
        <ExpandMore className={`color-icon-secondary expand-icon ${isExpanded ? "rotated" : ""}`} />
      </div>

      <div className={`payment-breakdown-table-wrapper ${isExpanded ? "visible" : ""}`}>
        <TableComponent
          columns={ONE_TIME_PAYMENT_BREAKDOWN_COLUMNS}
          data={tableData}
          clientSidePagination
          initialRowsPerPage={10}
          noBorderForSingleRow
          disableSort={false}
          alternatingRows
          tableHeadSmall
          tableCellSmall
          noBorder
        />
      </div>
    </div>
  );
}

export default OneTimePaymentBreakdown;
